import { render, staticRenderFns } from "./SellType.vue?vue&type=template&id=65bd7865&scoped=true&"
import script from "./SellType.vue?vue&type=script&lang=js&"
export * from "./SellType.vue?vue&type=script&lang=js&"
import style0 from "./SellType.vue?vue&type=style&index=0&id=65bd7865&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bd7865",
  null
  
)

export default component.exports